var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 32,
    fill: "#E51E25"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 46.6356C33 37.4358 40.6878 30 49.9868 30C59.3122 30 67 37.4358 67 46.6356C67 51.2714 65.314 55.5752 62.539 59.2232C59.4776 63.247 55.7044 66.753 51.457 69.5048C50.485 70.1408 49.6078 70.1888 48.5408 69.5048C44.2695 66.753 40.4962 63.247 37.461 59.2232C34.684 55.5752 33 51.2714 33 46.6356ZM44.3885 47.1536C44.3885 50.2354 46.9034 52.6594 49.9868 52.6594C53.0724 52.6594 55.6116 50.2354 55.6116 47.1536C55.6116 44.0956 53.0724 41.5537 49.9868 41.5537C46.9034 41.5537 44.3885 44.0956 44.3885 47.1536Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.67a47cc09013315ffcea3613fc67f98a.svg";
export { ForwardRef as ReactComponent };